module.exports = __webpack_public_path__ + "static/media/pig-orange.904dadb4.webp";